module.exports = __webpack_public_path__ + "img/1.187b5937.png";